import React from 'react';
import { Chip, withStyles, makeStyles, Typography, Divider, ListItemText, ListItem, List } from '@material-ui/core'
import { AssignmentTurnedIn } from '@material-ui/icons';
import { formatAs, getAsStartAndEndTimeFormat, formatDateRange, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';
import { PartialIcon } from '../core';
import { ShiftSegmentTypeName } from '../../../Enums';

const useStyles = makeStyles({
    headerPrimary: {
        fontSize: '20px',
        fontWeight: '700',
        fontFamily: 'Roboto'
    },
    headerSecondary: {
        fontSize: '12px',
        fontWeight: '500',
        fontFamily: 'Roboto'
    },
    number: {
        fontWeight: 'bold',
        marginRight: '12px',
    },
    transferIcon: {
        color: '#878787',
        marginRight: '8px',
    },
    chipFormatting: {
        fontSize: '13px',
        fontWeight: 'bold',
        color: '#0A54A2',
        backgroundColor: '#D4E0EC',
        borderRadius: '0px',
    },
    vtoChipFormatting: {
        fontSize: '13px',
        fontWeight: 'bold',
        color: '#006600',
        backgroundColor: '#c4ecc4',
        borderRadius: '0px',
    },
    openShiftChipFormatting: {
        fontSize: '13px',
        fontWeight: 'bold',
        color: '#EE0F0F',
        backgroundColor: 'rgba(236,12,12,0.16)',
        borderRadius: '0px',
    },
})
const TooltipListItemText = withStyles(
    () => ({
        primary: {
            fontSize: '14px',
            fontWeight: '500',
        }
    })
)(ListItemText);
const TooltipListItem = withStyles(
    () => ({
        root: {
            padding: '2px 14px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginBottom: '0px',
        }
    })
)(ListItem);
export default function SegmentList(props) {
    const classes = useStyles();

    const getShiftSegmentType = (type) => {
        switch (type) {
            case ShiftSegmentTypeName.TRANSFER_SEGMENT:
                return "Transfer (X)";
                break;
            case ShiftSegmentTypeName.BREAK_SEGMENT:
                return "Break";
                break;
            case ShiftSegmentTypeName.REGULAR_SEGMENT:
                return "Regular";
                break;
            default:
                return ""
                break;
        }
    }

    return (
        <List style={{ minWidth: '310px' }}>
            <ListItem>
                <>
                    {props.isVto
                        ? (<Chip size="small" className={classes.vtoChipFormatting} label="VTO" />)
                        : props.isOpenShift
                            ? (<Chip size="small" className={classes.openShiftChipFormatting} label="Open Shift" />)
                            : (<Chip size="small" className={classes.chipFormatting} label="Shift" />)
                    }
                    {props.isSignUp && <AssignmentTurnedIn className="signUpIconSize"/>}
                    {props.isPartial && <PartialIcon />}
                </>
            </ListItem>
            <TooltipListItem >
                <Typography className={classes.headerSecondary}>
                    {`(${formatAs(props.data.startDateTime, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)})`}
                </Typography>
            </TooltipListItem>
            <TooltipListItem >
                <Typography className={classes.headerPrimary}>{getAsStartAndEndTimeFormat(props.data.startDateTime, props.data.endDateTime)}</Typography>
            </TooltipListItem>
            <Divider />
            {props.data.segments?.map((item, index) => (
                <TooltipListItem key={`segment-tooltip-list-item-${item.id}`}>
                    <TooltipListItemText
                        primary={
                            <React.Fragment><span className={classes.number}>{index + 1}</span>
                                {
                                    `${getAsStartAndEndTimeFormat(item.startDateTime, item.endDateTime)} ${getShiftSegmentType(item.type)}`
                                }
                            </React.Fragment>
                        }
                    />
                    {
                        (item.orgJobRef) && (
                            <TooltipListItemText
                                secondary={item.orgJobRef.qualifier}
                            />
                        )
                    }
                    {
                        (item.costCenter) && (
                            <TooltipListItemText
                                secondary={item.costCenter.costCenter.qualifier}
                            />
                        )
                    }
                    {
                        (item.workruleRef  && item.workruleRef?.qualifier !== item.primaryWorkruleRef?.qualifier) && (
                            <TooltipListItemText
                                secondary={item.workruleRef.qualifier}
                            />
                        )
                    }
                </TooltipListItem>
            )
            )}
        </List>
    )
}